import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { GridRow, GridCol } from 'dibs-elements/exports/Grid';
import LinkColumnItem from './LinkColumn/LinkColumnItem';
import CurrencySelector from './CurrencySelector/CurrencySelector';
import CountrySelector from './CountrySelector/CountrySelector';
import { legalLinks } from './links';
import style from './FooterBottomRow.scss';

const LegalLinks = ({ filterLinks }) => {
    return (
        <GridCol desktop={5}>
            <ul className={style.legalLinkWrapper}>
                {filterLinks(legalLinks).map(link => (
                    <LinkColumnItem key={link.dataTn} {...link} isLegalLink />
                ))}
            </ul>
        </GridCol>
    );
};
LegalLinks.propTypes = {
    filterLinks: PropTypes.func,
    viewer: PropTypes.object,
};

const LocalizationSelectors = ({ isClient, viewer }) => (
    <GridCol desktop={7}>
        <div className={style.dropdowns}>
            <CurrencySelector isClient={isClient} viewer={viewer} user={viewer.user || null} />
            <CountrySelector isClient={isClient} />
        </div>
    </GridCol>
);

LocalizationSelectors.propTypes = {
    isClient: PropTypes.bool,
    viewer: PropTypes.object,
};

const FooterBottomRowComponent = ({ filterLinks, viewer, isClient }) => {
    return (
        <div className={style.footerBottomRow}>
            <GridRow align="center">
                <LegalLinks filterLinks={filterLinks} viewer={viewer} />
                <LocalizationSelectors isClient={isClient} viewer={viewer} />
            </GridRow>
        </div>
    );
};

FooterBottomRowComponent.propTypes = {
    filterLinks: PropTypes.func,
    viewer: PropTypes.object,
    isClient: PropTypes.bool,
};

export const FooterBottomRow = createFragmentContainer(FooterBottomRowComponent, {
    viewer: graphql`
        fragment FooterBottomRow_viewer on Viewer {
            user(userId: $userId) @include(if: $hasUserId) {
                ...CurrencySelector_user
            }
            ...CurrencySelector_viewer
        }
    `,
});
